import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { ProjectTemplateTask } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getProjectTemplateTask = () =>
  createSelector(
    (state: RootState) => state.templates.project.data,
    (_, { taskId, templateId }) => ({ taskId, templateId }),
    (data, { taskId, templateId }): ProjectTemplateTask =>
      data[templateId].tasks[taskId],
  );

export const useProjectTemplateTask = (taskId: number): ProjectTemplateTask => {
  const templateId = useActiveTemplateId();
  const taskObject = useMemo(getProjectTemplateTask, []);

  return useSelector((state: RootState) => {
    return taskObject(state, { taskId, templateId });
  });
};
